import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import getValidationSchemaStep1 from '../ValidationSchema/Step1ValidationSchema';
import { FormikProvider, useFormik } from 'formik';
import AddMembersModal from '../AddMembersModal';
import 'react-quill/dist/quill.snow.css';
import CustomizedSelect from '../../../Atoms/Inputs/CustomizedSelect';
import closeGreen from '../../../../assets/Imagess/close-green.svg';
import styles from '../Steps.module.scss';
import noImageFound from '../../../../assets/Imagess/no-image-found.jpg';
import emailSvg from '../../../../assets/icons/formActions/inputs/email.svg';
import folderIcon from '../../../../assets/Imagess/folderICon.svg';
import clockIcon from '../../../../assets/Imagess/clock.svg';
import calendarIcon from '../../../../assets/Imagess/calendar-icon.svg';
import languageIcon from '../../../../assets/Imagess/language.svg';
import entryLevelIcon from '../../../../assets/Imagess/entry-level.svg';
import hashIcon from '../../../../assets/Imagess/hash.svg';
import addIcon from '../../../../assets/Imagess/addIcon.svg';
import emailIcon from '../../../../assets/Imagess/mail.svg';
import Buttons from '../../../Atoms/Buttons/Buttons';
import { API_URL, securityHeaders } from '../../../../Constants';
import { useMutation } from 'react-query';
import axios from 'axios';
import { toast } from 'react-toastify';
import TextInput from '../../../Atoms/Inputs/TextInput';
import TextEditor from '../../Email/TextEditor';
import { useToast } from '../../Custom/CustomToaster/Toast';
import Loader from '../../Loader/Loader';
import {
  useBulkAddTestimonials,
  useFetchTestimonialByKeyLocation,
} from '../../../../Hooks/Testimonials';
import closeIcon from '../../../../assets/Imagess/close-green.svg';
import he from 'he';
import CustomizedSelectwithCheckbox from '../../../Atoms/Inputs/CustomizedSelectwithCheckbox';
import Testimonial from '../../SpeechAndTestimonials/Testimonial';
import AddIconModal, { getIconByName } from '../AddIconModal';
import { sanitizeAndValidateUrl } from '../../../../app/helpers/sanitizeAndValidateUrl';
import CustomSelect from '../../../Atoms/forms/customSelect/CustomSelect';
const degreeTypes = [
  {
    value: 0,
    text: 'بكالوريوس',
  },
  {
    value: 1,
    text: 'ماجستير',
  },
  {
    value: 2,
    text: 'دكتوراه',
  },
];

const languageOptions = [
  {
    value: 1,
    text: 'الإنجليزية',
  },
  {
    value: 2,
    text: 'العربية والإنجليزية',
  },
  {
    value: 3,
    text: 'العربية',
  },
];

const cadetsOptions = [
  {
    value: 0,
    text: 'For All',
  },
  {
    value: 1,
    text: 'Cadets',
  },
];

const ProgramFirstStep = forwardRef(
  (
    { id, degree, refetchProgram, setDegreeId, isLoading, setStep, mode },
    ref
  ) => {
    const customizedToast = useToast();
    const [init, setInit] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [sections, setSections] = useState(1);
    const [pass, setPass] = useState({
      testimonial: false,
      programOutcom: false,
    });
    const { data: testimonial } = useFetchTestimonialByKeyLocation('HomePage');
    const { mutate: addTestimonial } = useBulkAddTestimonials();
    const [selectedTestimonial, setSelectedTEstimonial] = useState([]);
    const [currentEditingIndex, setCurrentEditingIndex] = useState(null);
    const [isIconModalOpen, setIsIconModalOpen] = useState(false);

    useEffect(() => {
      const initialvalues = {
        DegreeId:
          degree?.degree?.degreeId || '00000000-0000-0000-0000-000000000000',
        DegreeType: degree?.degree?.degreeType,
        DegreeNameAr: degree?.degree?.degreeNameAr || '',
        EntryLevelAr: degree?.degree?.entryLevelAr || '',
        CreditHours: degree?.degree?.creditHours || '',
        DurationAr: degree?.degree?.durationAr || '',
        Languages: degree?.degree?.languages,
        AboutProgramAr: he.decode(degree?.degree?.aboutProgramAr || ''),
        TotalGraduates: degree?.degree?.totalGraduates || '',
        RequiredCourses: degree?.degree?.requiredCourses || '',
        ElectiveCourses: degree?.degree?.electiveCourses || '',
        HighlightsAr: he.decode(degree?.degree?.highlightsAr || ''),
        ForAllOrCadets: degree?.degree?.forAllOrCadets,
        Accreditation: degree?.degree?.accreditation || '',
        programOutcomes:
          degree?.degreeOutComes && degree?.degreeOutComes.length > 0
            ? degree?.degreeOutComes?.map((test) => ({
                DegreeId: test.DegreeId,
                ProgramOutComeId: test.programOutComeId,
                OutComeAr: test.outComeAr,
                OutComeImage: test.imageUrl,
              }))
            : [
                {
                  ProgramOutComeId: '00000000-0000-0000-0000-000000000000',
                  OutComeAr: '',
                  OutComeImage: '',
                },
              ],
        ApprovedFees: degree?.degree?.approvedFees || '',
        KnowledgeInnovation: degree?.degree?.knowledgeInnovation || '',
      };
      setInit(initialvalues);
      setSelectedTEstimonial(
        degree?.degreeTestimonials?.map(({ testimonialId, fullName_EN }) => ({
          value: testimonialId,
          text: fullName_EN,
        }))
      );
    }, [degree]);

    const handleIconClick = (index) => {
      setCurrentEditingIndex(index);
      setIsIconModalOpen(true);
    };

    const handleIconSelect = (icon) => {
      formik.setFieldValue(
        `programOutcomes[${currentEditingIndex}].OutComeImage`,
        icon
      );
      setIsIconModalOpen(false);
    };

    const addSection = () => {
      const newSection = {
        ProgramOutComeId: '00000000-0000-0000-0000-000000000000',
        OutComeAr: '',
        // OutComeImage: "",
      };
      formik.setFieldValue('programOutcomes', [
        ...formik.values.programOutcomes,
        newSection,
      ]);
      setSections(sections + 1);
    };

    const handleSubmitProgramOutcome = useMutation({
      mutationFn: (fields) => {
        return axios.post(API_URL + `/api/Degree/ProgramOutcome`, fields, {
          headers: securityHeaders,
        });
      },
      onSuccess: (data) => {
        setPass((prevPass) => ({
          ...prevPass,
          programOutcom: true,
        }));
      },
      onError: (error) => {
        toast.error(error?.message);
      },
    });
    const handleSubmitSelectedTestimonials = (programId) => {
      if (selectedTestimonial && selectedTestimonial?.length > 0) {
        const testimonialsById = selectedTestimonial?.map((item) => item.value);
        const result = {
          testimonialId: testimonialsById,
          degreeId: programId,
        };
        addTestimonial(
          {
            testimonialId: testimonialsById,
            degreeId: programId,
          },
          {
            onSuccess: () => {
              setPass((prevPass) => ({
                ...prevPass,
                testimonial: true,
              }));
            },
          }
        );
      } else {
        setPass((prevPass) => ({
          ...prevPass,
          testimonial: true,
        }));
      }
    };

    const handleStep1Submit = useMutation({
      mutationFn: (fields) => {
        return axios.post(API_URL + `/api/Degree/Stage1Degree`, fields, {
          headers: securityHeaders,
        });
      },
      onSuccess: (data) => {
        setDegreeId(data?.data?.degreeId);
        if (
          formik.values?.programOutcomes &&
          formik.values?.programOutcomes?.length > 0
        ) {
          if (data?.data?.degreeId || id) {
            const formDataFiles = new FormData();
            formik.values.programOutcomes.forEach((file, index) => {
              formDataFiles.append(
                `programOutcomes[${index}].DegreeId`,
                data?.data?.degreeId || id
              );
              formDataFiles.append(
                `programOutcomes[${index}].ProgramOutComeId`,
                file.ProgramOutComeId
              );

              formDataFiles.append(
                `programOutcomes[${index}].OutComeAr`,
                file.OutComeAr
              );

              if (file?.OutComeImage) {
                const fileExtension = file.OutComeImage.split('.')
                  .pop()
                  .toLowerCase();

                const fileName =
                  fileExtension === 'svg'
                    ? file.OutComeImage
                    : `${file.OutComeImage}.svg`;

                formDataFiles.append(
                  `programOutcomes[${index}].OutComeImage`,
                  fileName
                );
              }
            });
            handleSubmitProgramOutcome.mutate(formDataFiles);
          }
        } else {
          setPass((prevPass) => ({
            ...prevPass,
            programOutcom: true,
          }));
        }
        handleSubmitSelectedTestimonials(data?.data?.degreeId || id);
      },
      onError: (error) => {
        toast.error(error?.message);
      },
    });

    useEffect(() => {
      if (pass.programOutcom && pass.testimonial) {
        setStep((prev) => prev + 1);
      }
      setTimeout(() => {
        setPass((prevPass) => ({
          ...prevPass,
          testimonial: false,
          programOutcom: false,
        }));
      }, [1000]);
    }, [pass.programOutcom, pass.testimonial]);

    const deselectItem = useMutation({
      mutationFn: (fields) => {
        return axios.post(
          API_URL + `/api/Degree/RemoveDegreeFacultyLink/${fields.linkId}`,
          {},
          {
            headers: securityHeaders,
          }
        );
      },
      onSuccess: (data) => {
        customizedToast.open('تم الحذف بنجاح');
        refetchProgram();
      },
      onError: (error) => {
        toast.error(error?.message);
      },
    });
    const removeSection = (index) => {
      if (formik.values.programOutcomes.length === 1) {
        formik.setFieldValue('programOutcomes', [
          {
            ProgramOutComeId: '',
            OutComeAr: '',
            DegreeId: '',
          },
        ]);
      } else {
        const newFiles = formik.values.programOutcomes.filter(
          (_, i) => i !== index
        );
        formik.setFieldValue('programOutcomes', newFiles);
        setSections(sections - 1);
      }
    };

    const isAnyFieldFilled = (section) => {
      return Object.values(section).some((value) => value !== '');
    };
    const formik = useFormik({
      initialValues: init,
      validationSchema: getValidationSchemaStep1(),
      enableReinitialize: true,
      onSubmit: (values) => {
        var formData = new FormData();
        formData.append('DegreeId', values.DegreeId);
        formData.append('DegreeType', values.DegreeType);
        formData.append('DegreeNameAr', values.DegreeNameAr);
        formData.append('EntryLevelAr', values.EntryLevelAr);
        formData.append('CreditHours', values.CreditHours);
        formData.append('DurationAr', values.DurationAr);
        formData.append('Languages', values.Languages);
        formData.append('AboutProgramAr', values.AboutProgramAr);
        formData.append('TotalGraduates', values.TotalGraduates);
        formData.append('RequiredCourses', values.RequiredCourses);
        formData.append('Accreditation', values.Accreditation);
        formData.append('ElectiveCourses', values.ElectiveCourses);
        formData.append('HighlightsAr', values.HighlightsAr);
        formData.append('ForAllOrCadets', values.ForAllOrCadets);
        formData.append('ApprovedFees', values.ApprovedFees);
        formData.append('KnowledgeInnovation', values.KnowledgeInnovation);
        handleStep1Submit.mutate(formData);
      },
    });
    console.log('vdnvjk', formik);
    useImperativeHandle(ref, () => ({
      submitForm: () => {
        formik.submitForm();
      },
    }));

    useEffect(() => {
      ref.current = formik;
    }, [ref, formik]);

    if (isLoading) {
      <Loader />;
    }

    return (
      <div className={styles.form}>
        <FormikProvider value={formik} innerRef={ref}>
          <div className={styles.grid}>
            <CustomSelect
              label='نوع الدرجة' // Degree Type
              placeholder='اختر نوع الدرجة' // Select degree type
              icon={emailSvg}
              options={degreeTypes}
              value={formik.values.DegreeType}
              name='DegreeType'
              selectedTextKey='key'
              onChange={(name, value) => {
                formik.setFieldValue(name, value);
              }}
              errors={formik.errors.DegreeType}
              touched={formik.touched.DegreeType}
              right
            />
            <TextInput
              label='المستوى الدراسي' // Entry level
              placeholder='أدخل المستوى الدراسي' // Enter entry level
              icon={entryLevelIcon}
              value={formik.values.EntryLevelAr}
              name='EntryLevelAr'
              onChange={(name, value) => {
                formik.setFieldValue(name, value);
              }}
              errors={formik.errors.EntryLevelAr}
              touched={formik.touched.EntryLevelAr}
              left
            />
            <TextInput
              label='الاسم' // Name
              placeholder='أدخل الاسم' // Enter Name
              icon={folderIcon}
              value={formik.values.DegreeNameAr}
              name='DegreeNameAr'
              onChange={(name, value) => {
                formik.setFieldValue(name, value);
              }}
              errors={formik.errors.DegreeNameAr}
              touched={formik.touched.DegreeNameAr}
              left
            />
            <TextInput
              label='عدد الساعات المعتمدة' // Credit Hours
              placeholder='أدخل عدد الساعات المعتمدة' // Enter Credit Hours
              icon={clockIcon}
              value={formik.values.CreditHours}
              name='CreditHours'
              type='number'
              onChange={(name, value) => {
                formik.setFieldValue(name, value);
              }}
              errors={formik.errors.CreditHours}
              touched={formik.touched.CreditHours}
              left
            />
            <CustomSelect
              label='اللغة' // Language
              placeholder='أدخل اللغة' // Enter Language
              icon={languageIcon}
              options={languageOptions}
              selectedTextKey='key'
              value={formik.values.Languages}
              name='Languages'
              onChange={(name, value) => {
                formik.setFieldValue(name, value);
              }}
              errors={formik.errors.Languages}
              touched={formik.touched.Languages}
              right
            />
            <TextInput
              label='مدة السنة' // Year Duration
              placeholder='ادخل السنة' // Enter the year
              icon={calendarIcon}
              value={formik.values.DurationAr}
              name='DurationAr'
              onChange={(name, value) => {
                formik.setFieldValue(name, value);
              }}
              errors={formik.errors.DurationAr}
              touched={formik.touched.DurationAr}
              left
            />{' '}
            <TextInput
              label='الرسوم المعتمدة'
              placeholder='أدخل الرسوم المعتمدة'
              type='number'
              icon={hashIcon}
              value={formik.values.ApprovedFees}
              name='ApprovedFees'
              onChange={(name, value) => {
                formik.setFieldValue(name, value);
              }}
              errors={formik.errors.ApprovedFees}
              touched={formik.touched.ApprovedFees}
            />
            <TextInput
              label='الابتكار المعرفي'
              placeholder='أدخل قيمة الابتكار المعرفي'
              type='number'
              icon={hashIcon}
              value={formik.values.KnowledgeInnovation}
              name='KnowledgeInnovation'
              onChange={(name, value) => {
                formik.setFieldValue(name, value);
              }}
              errors={formik.errors.KnowledgeInnovation}
              touched={formik.touched.KnowledgeInnovation}
            />
          </div>

          <div className={`${styles['quill-container']} `}>
            <TextEditor
              label='نبذة عن البرنامج' // Program Description
              name='AboutProgramAr'
              value={formik.values.AboutProgramAr}
              onChange={(name, value) => {
                formik.setFieldValue(name, value);
              }}
              errors={formik.errors.AboutProgramAr}
              touched={formik.touched.AboutProgramAr}
              right
            />
          </div>

          <div className={styles['step-container']}>
            <p className={styles['title']}>الإحصائيات</p>
            <div className={styles.grid}>
              <TextInput
                label='عدد الخريجين'
                placeholder='أدخل العدد'
                icon={hashIcon}
                value={formik.values.TotalGraduates}
                type='number'
                name='TotalGraduates'
                onChange={(name, value) => {
                  formik.setFieldValue(name, value);
                }}
                errors={formik.errors.TotalGraduates}
                touched={formik.touched.TotalGraduates}
              />
              <TextInput
                label='عدد الدورات المطلوبة'
                placeholder='أدخل العدد'
                type='number'
                icon={hashIcon}
                value={formik.values.RequiredCourses}
                name='RequiredCourses'
                onChange={(name, value) => {
                  formik.setFieldValue(name, value);
                }}
                errors={formik.errors.RequiredCourses}
                touched={formik.touched.RequiredCourses}
              />
              <TextInput
                label='عدد الدورات الاختيارية'
                placeholder='أدخل العدد'
                type='number'
                icon={hashIcon}
                value={formik.values.ElectiveCourses}
                name='ElectiveCourses'
                onChange={(name, value) => {
                  formik.setFieldValue(name, value);
                }}
                errors={formik.errors.ElectiveCourses}
                touched={formik.touched.ElectiveCourses}
              />
              <CustomizedSelect
                label='لجميع الطلاب أو cadets'
                placeholder='اختر خيار'
                options={cadetsOptions}
                icon={emailIcon}
                onChange={(name, value) => {
                  formik.setFieldValue(name, value);
                }}
                name='ForAllOrCadets'
                value={formik.values.ForAllOrCadets}
                errors={formik.errors.ForAllOrCadets}
                touched={formik.touched.ForAllOrCadets}
              />
            </div>
          </div>

          <div className={`${styles['quill-container']} ${styles['rtl']}`}>
            <TextEditor
              label='أهداف البرنامج' // Highlights
              name='HighlightsAr'
              value={formik.values.HighlightsAr}
              onChange={(name, value) => {
                formik.setFieldValue(name, value);
              }}
              errors={formik.errors.HighlightsAr}
              touched={formik.touched.HighlightsAr}
              right
            />
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            <p className={styles['title']}>مخرجات البرنامج</p>
          </div>
          {formik.values.programOutcomes &&
            formik.values.programOutcomes.map((section, index) => {
              return (
                <div key={index} className={styles['programOutcome-container']}>
                  {(formik.values.programOutcomes.length > 1 ||
                    isAnyFieldFilled(section)) && (
                    <div
                      className={styles['remove_text']}
                      onClick={() => removeSection(index)}
                    >
                      <img src={closeIcon} alt='removeIcon' />
                      {/* <h6>
              {formik.values.programOutcomes.length === 1
                ? 'Clear' // مسح
                : 'Remove'} // إزالة
            </h6> */}
                    </div>
                  )}
                  <div className={styles['text-input-container']}>
                    <TextInput
                      label='المحتوى' // Content
                      placeholder='أدخل المحتوى' // Enter content
                      left
                      onChange={(name, value) => {
                        formik.setFieldValue(name, value);
                      }}
                      value={section.OutComeAr}
                      name={`programOutcomes[${index}].OutComeAr`}
                      errors={
                        formik.errors?.programOutcomes?.[index]?.OutComeAr
                      }
                      touched={
                        formik.touched?.programOutcomes?.[index]?.OutComeAr
                      }
                    />
                  </div>
                  <div
                    className={styles['add-icon-container']}
                    onClick={() => handleIconClick(index)}
                  >
                    <label>إضافة أيقونة</label> {/* Add Icon */}
                    <div className={styles.imageContainer}>
                      <img
                        src={
                          getIconByName(section?.OutComeImage)?.src ?? addIcon
                        }
                        className={styles.icon}
                      />
                    </div>
                  </div>
                </div>
              );
            })}

          <div className={styles.right}>
            <Buttons
              text='أضف المزيد'
              rounded={true}
              color='rgba(13, 160, 110, 1)'
              handleOnClick={addSection}
              style={{
                fontFamily: 'BukraMedium',
                width: 'unset',
                marginTop: '25px',
              }}
            />
          </div>

          {mode != 'add' && (
            <>
              <div className={styles['steps']} style={{ marginTop: '80px' }}>
                <div>
                  <p className={styles['title']}>عضو الفريق المرتبط</p>
                  <Buttons
                    text='إضافة عضو'
                    rounded={true}
                    color='rgba(13, 160, 110, 1)'
                    handleOnClick={() => setIsModalOpen(true)}
                    style={{
                      fontFamily: 'BukraMedium',
                      width: 'unset',
                      marginTop: '20px',
                    }}
                  />
                </div>
              </div>
              <div className={styles.memberContainer}>
                {degree?.degreeFaculties &&
                  degree?.degreeFaculties.map((item, index) => {
                    return (
                      <div className={styles['selected-item']} key={index}>
                        <img
                          src={sanitizeAndValidateUrl(
                            `${item?.url}${item?.facultyImage}`
                          )}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = noImageFound;
                          }}
                          className={styles['image']}
                        />
                        <p>{item?.fullName_AR}</p>
                        <img
                          src={closeGreen}
                          className={styles['close-green']}
                          onClick={() => deselectItem.mutate(item)}
                        />
                      </div>
                    );
                  })}
              </div>
            </>
          )}

          <div className={styles['steps']} style={{ marginTop: '80px' }}>
            <CustomizedSelectwithCheckbox
              options={testimonial?.data?.map(
                ({ testimonialId, fullName_AR, testimonial_AR }) => ({
                  value: testimonialId,
                  text:
                    fullName_AR +
                    ' - ' +
                    he
                      .decode(testimonial_AR.substring(0, 100))
                      .replace('<p>', '') +
                    ' ... ',
                })
              )}
              label='شهادات البرنامج'
              placeholder='اختر الشهادات'
              icon={emailIcon}
              onChange={(name, value) => {
                formik.setFieldValue(name, value);
                setSelectedTEstimonial(value);
              }}
              value={selectedTestimonial}
              scroll
            />
          </div>
          <div
            className={styles['major-box-grid']}
            style={{ paddingTop: '10px' }}
          >
            {degree?.degreeTestimonials?.map((testimonial) => (
              <Testimonial
                testimonial={testimonial}
                key={testimonial?.testimonialId}
                view
              />
            ))}
          </div>
        </FormikProvider>
        {isIconModalOpen && (
          <AddIconModal
            handleOnClose={() => setIsIconModalOpen(false)}
            onIconSelect={handleIconSelect}
          />
        )}
        {isModalOpen && (
          <AddMembersModal
            title='Course'
            handleOnClose={() => setIsModalOpen(false)}
            refetchProgram={refetchProgram}
            id={id}
          />
        )}
      </div>
    );
  }
);
export default ProgramFirstStep;
